import React from "react";

function ExpensesList({ expenseList }) {
  const amountArr = expenseList.map((item) => item.amount);
  const amountSum = amountArr.reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);
  return (
    <div className="rounded-md border border-lg5 shadow-md mt-4">
      <button className="text-dark-blue 2xs:max-lg:text-sm px-4 pt-4 pb-1 w-full text-left font-semibold font-figtree">
        Sheet Details
      </button>
      <>
        <div className={`px-4 pb-4`}>
          <div className="overflow-y-auto max-h-[400px] border-1 border-lg5 border-t-0 text-center">
            <table className={`w-full`}>
              <thead
                className={`text-white font-poppins text-sm font-extralight bg-dark-blue 2xs:max-sm:text-sm sticky top-0`}
              >
                <th className="border border-lg5 py-2">Expense ID</th>
                <th className="border border-lg5">User</th>
                <th className="border border-lg5">Receiver</th>
                <th className="border border-lg5">Amount</th>
                <th className="border border-lg5">Category</th>
              </thead>
              <tbody className="font-figtree 2xs:max-sm:text-xs">
                {expenseList.map((expense, ind) => {
                  return (
                    <tr key={ind} className="text-sm odd:bg-white even:bg-lg6">
                      <td className="border border-lg5 py-2"> {expense.id}</td>
                      <td className="border border-lg5">
                        {expense.user.fullName}
                      </td>
                      <td className="border border-lg5">
                        {expense.receiver
                          ? `${expense.receiver.fullName} - ${expense.receiver.id}`
                          : "-"}
                      </td>
                      <td className="border border-lg5">{`₹${expense.amount}`}</td>
                      <td className="border border-lg5">
                        {expense.category.name}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <table class="w-full table-fixed mt-2">
            <tbody>
              <tr className="bg-lg6">
                <td class="p-2 border border-lg5 text-dark-blue font-figtreeMedium text-sm">
                  Total Expenses : {expenseList.length}
                </td>
                <td class="p-2 border border-lg5 text-dark-blue font-figtreeMedium text-sm">
                  Total Amount : {`Rs. ${amountSum}/-`}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    </div>
  );
}

export default ExpensesList;
